import { render } from "./GuidelineRelated.vue?vue&type=template&id=5e951390&scoped=true"
import script from "./GuidelineRelated.vue?vue&type=script&lang=js"
export * from "./GuidelineRelated.vue?vue&type=script&lang=js"

import "./GuidelineRelated.vue?vue&type=style&index=0&id=5e951390&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e951390"]])

export default __exports__